export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a procesos"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["contenedores"])},
          "total_number_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inspecciones"])},
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrar"])},
          "clear_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limpiar"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to processes"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["containers"])},
          "total_number_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inspections"])},
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])},
          "clear_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear"])}
        }
      }
    }
  })
}